<template>
  <userForm
    :user="user"
    :card-title="userUid ?
      $t('Components.Forms.UserDetails.Titles.ExistingUser') :
      $t('Components.Forms.UserDetails.Titles.NewUser')"
    :is-new-user="isNewUser"
    :loading="loading.commit"
    :bad-request-reasons="badRequestReasons"
    @saveUser="saveUserHandler"
    @closeUserForm="closeUserFormHandler"
    @saveAndCloseUserForm="saveAndCloseUserFormHandler"
  />
</template>

<script>
  import userForm from '../components/custom/forms/UserForm'

  export default {
    components: {
      userForm,
    },
    props: {
      userUid: {
        type: String,
        required: false,
        default: null,
      },
      role: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
      user: {
        uid: '',
        firstName: '',
        lastName: '',
        email: '',
        resellerUid: '',
        role: '',
        password: '',
      },
      loading: {
        commit: false,
      },
      badRequestReasons: {},
    }),
    computed: {
      users () {
        return this.$store.state.users.list
      },
      isNewUser () {
        return !this.userUid
      },
    },
    created: async function () {
      if (this.users.length < 1) {
        await this.$store.dispatch('RefreshUsers')
      }

      if (!this.userUid) {
        return
      }

      var currentUser = this.users.find(
        el => el.uid === this.userUid
      )

      if (!currentUser) {
        await this.$store.dispatch('RefreshUsers')
        currentUser = this.users.find(
          el => el.uid === this.userUid
        )
        if (!currentUser) {
          console.log('[Unable to find user by UID]')
          return
        }
      }
      this.updateLocalUser(currentUser)
    },
    methods: {
      async saveUserHandler (user) {
        this.loading.commit = true
        var storeChange
        var dispatchEvent = !this.user.uid ? 'CreateUser' : 'UpdateUser'
        var eventLoadingMsg = !this.user.uid
          ? this.$t('Components.Forms.UserDetails.Messages.UserCreateSubmitLoadMessage')
          : this.$t('Components.Forms.UserDetails.Messages.UserUpdateSubmitLoadMessage')

        storeChange = await this.$store.dispatch(dispatchEvent, user, eventLoadingMsg)

        if (storeChange.success === true) {
          this.updateLocalUser(storeChange.value)
          this.loading.commit = false
          return true
        } else {
          this.badRequestReasons = storeChange.badRequestReasons.errors
        }

        this.loading.commit = false
        return false
      },
      async saveAndCloseUserFormHandler (user) {
        if (await this.saveUserHandler(user)) {
          this.closeUserFormHandler()
        }
      },
      closeUserFormHandler () {
        this.$router.go(-1)
      },
      updateLocalUser (data) {
        this.user.uid = data.uid
        this.user.firstName = data.firstName
        this.user.lastName = data.lastName
        this.user.email = data.email
        this.user.resellerUid = data.resellerUid
        this.user.role = data.role
      },
    },
  }
</script>
